import ReactGA from "react-ga4";


const email = localStorage.getItem("email") ?? "";
const companyId = localStorage.getItem("company_id") ?? "";
const companyName = localStorage.getItem("company_name") ?? "";

export const getCompanyId = () => {
  return localStorage.getItem("company_id") || "";
};





export const gaPanelConfig = {
  logged_In: email === "" ? "NO" : "YES",
  AppName: '',
  BtnText: '',
  AppID: '',
  DeveloperName: '',
  DeveloperID: '',
  AppSlug: '',
  device: '',
  company_Id: companyId,
  CompanyName: companyName,
  PageUrl: '',
  Write_a_Review: "",
  AppStatus: "",
  CardSection: "",
  current_url: "",
  company_name: "",
  search_term: "",
  select_item: "",
  select_result: "",
  blog_url:"",
  JoinforFree:""








};

export const captureGAEvent = (category: string, event: any) => {
  ReactGA.gtag('event', event, {
    category: category,
    logged_In: gaPanelConfig.logged_In,
    AppName: gaPanelConfig.AppName,
    AppID: gaPanelConfig.AppID,
    DeveloperName: gaPanelConfig.DeveloperName,
    BtnText: gaPanelConfig.BtnText,
    DeveloperID: gaPanelConfig.DeveloperID,
    AppSlug: gaPanelConfig.AppSlug,
    MobileDesktop: gaPanelConfig.device,
    company_Id: gaPanelConfig.company_Id,
    company_name: gaPanelConfig.company_name,
    PageUrl: window.location.href,
    search_term: gaPanelConfig.search_term,
    select_item: gaPanelConfig.select_item,
    select_result: gaPanelConfig.select_result,
    Write_a_Review: gaPanelConfig.Write_a_Review,
    AppStatus: gaPanelConfig.AppStatus,
    CardSection: gaPanelConfig.CardSection,
    current_url: window.location.href,
    blog_url:gaPanelConfig.blog_url,
    JoinforFree:gaPanelConfig.JoinforFree
  })





  // ReactGA.gtag("event",event, {
  //   category: category,
  //   LoggedIn: gaPanelConfig.LoggedIn,
  //   AppName: gaPanelConfig.AppName,
  //   AppID: gaPanelConfig.AppID,
  //   DeveloperName: gaPanelConfig.DeveloperName,
  //   BtnText: gaPanelConfig.BtnText,
  //   DeveloperID: gaPanelConfig.DeveloperID,
  //   AppSlug: gaPanelConfig.AppSlug,
  //   MobileDesktop: gaPanelConfig.MobileDesktop,
  //   CompanyId: gaPanelConfig.CompanyId,
  //   CompanyName: gaPanelConfig.CompanyName,
  //   PageUrl: window.location.href,
  //   Search: gaPanelConfig.Search,
  //   Write_a_Review: gaPanelConfig.Write_a_Review,
  //   AppStatus: gaPanelConfig.AppStatus,
  //   CardSection: gaPanelConfig.CardSection,


  // })
};
// export const captureGAEvent = (category: string, event: any) => {
//   ReactGA.event(category, {
//     event: event,
//     LoggedIn: gaPanelConfig.LoggedIn,
//     AppName: gaPanelConfig.AppName,
//     AppID: gaPanelConfig.AppID,
//     DeveloperName: gaPanelConfig.DeveloperName,
//     BtnText: gaPanelConfig.BtnText,
//     DeveloperID: gaPanelConfig.DeveloperID,
//     AppSlug: gaPanelConfig.AppSlug,
//     MobileDesktop: gaPanelConfig.MobileDesktop,
//     CompanyId: gaPanelConfig.CompanyId,
//     CompanyName: gaPanelConfig.CompanyName,
//     PageUrl: window.location.href,
//     Search: gaPanelConfig.Search,
//     Write_a_Review: gaPanelConfig.Write_a_Review,
//     AppStatus: gaPanelConfig.AppStatus,
//     CardSection: gaPanelConfig.CardSection,


//   })
// };





